// @WIP
export const RULES = {
  HOME: ['SYSADMIN', 'ADMIN', 'COORDIDATOR', 'MANAGER', 'OPERATIONAL', 'GUEST'],

  /*
|---------------------------------------------------------------|
|                    Ao retornar false deve:                    |
|---------------------------------------------------------------|
|    _LIST   = [SideBarContent.js] remove a opção no menu       |
|    _LIST   = [Listagem] muda a rota para "/home"              |
|    _READ   = [Listagem] remove lápis da "listagem"            |
|    _CREATE = [Listagem] remove o botão "novo"                 |
|    _READ   = [Create] muda a rota para "/home"                |
|    _CREATE = [Create] remove o botão "salvar"                 |
|    _UPDATE = [Create] remove botão salvar                     |
|---------------------------------------------------------------|
*/

  // acessos entitlements
  DASHBOARD: ['DASHBOARD', 'SYSADMIN'],

  // < customer >
  CUSTOMER: ['CUSTOMER', 'SYSADMIN'],

  // < customer location >
  CUSTOMER_LOCATION: ['CUSTOMER_LOCATION', 'SYSADMIN'],

  // < customer location >
  CUSTOMER_CONTACT: ['CUSTOMER_CONTACT', 'SYSADMIN'],

  // < forecast >
  FORECAST: ['FORECAST', 'SYSADMIN'],

  // < customer links wallet >
  CUSTOMER_LINKS: ['CUSTOMER_LINKS', 'SYSADMIN'],

  // < actions >
  ACTION: ['ACTION', 'SYSADMIN'],

  // < action type >
  ACTION_TYPE: ['ACTION_TYPE', 'SYSADMIN'],

  // < action type JSON >
  ACTION_TYPE_JSON: ['ACTION_TYPE_JSON', 'SYSADMIN'],

  // < action template >
  ACTION_TEMPLATE: ['ACTION_TEMPLATE', 'SYSADMIN'],

  // < member type >
  MEMBER_TYPE: ['MEMBER_TYPE', 'SYSADMIN'],

  // < member type >
  LOCATION_TYPE: ['LOCATION_TYPE', 'SYSADMIN'],

  // < member >
  MEMBER: ['MEMBER', 'SYSADMIN'],

  // < customer type >
  CUSTOMER_TYPE: ['CUSTOMER_TYPE', 'SYSADMIN'],

  // < district >
  DISTRICT: ['DISTRICT', 'SYSADMIN'],

  // < reference period >
  REFERENCE_PERIOD: ['REFERENCE_PERIOD', 'SYSADMIN'],

  // < region >
  REGION: ['REGION', 'SYSADMIN'],

  // < permissões / profiles >
  PROFILE: ['PROFILE', 'SYSADMIN'],

  // < config document >
  CONFIG_DOCUMENT: ['CONFIG_DOCUMENT', 'SYSADMIN'],

  // < report >
  REPORT: ['REPORT', 'SYSADMIN'],

  // < region links / hierarchies >
  REGION_LINKS: ['REGION_LINKS', 'SYSADMIN'],

  MATERIAL: ['MATERIAL', 'SYSADMIN'],

  DATALOAD: ['DATALOAD', 'SYSADMIN'],

  CATEGORY: ['CATEGORY', 'SYSADMIN'],

  ACTIONPLAN: ['ACTIONPLAN', 'SYSADMIN', ''],

  ACAO: ['ACAO', 'SYSADMIN'],

  CULTIVARS: ['CULTIVARS', 'SYSADMIN'],

  // < import files >
  FILE_IMPORT_LIST: ['FILE_IMPORT_LIST', 'SYSADMIN'],
  FILE_IMPORT_CUSTOMER: ['FILE_IMPORT_CUSTOMER', 'SYSADMIN'],
  FILE_IMPORT_MEMBER: ['FILE_IMPORT_MEMBER', 'SYSADMIN'],
  FILE_IMPORT_LOCATION: ['FILE_IMPORT_LOCATION', 'SYSADMIN'],
  FILE_IMPORT_REGION: ['FILE_IMPORT_REGION', 'SYSADMIN'],
  FILE_IMPORT_DISTRICT: ['FILE_IMPORT_DISTRICT', 'SYSADMIN'],
  FILE_IMPORT_CUSTOMER_LINKS: ['FILE_IMPORT_CUSTOMER_LINKS', 'SYSADMIN'],
  FILE_IMPORT_REGION_LINKS: ['FILE_IMPORT_REGION_LINKS', 'SYSADMIN'],
  TEAM: ['ADMIN', 'SYSADMIN'],

  // Todos devem ter acesso ao botão de logout
  LOGOUT: ['ADMIN', 'SYSADMIN', 'COORDIDATOR', 'MANAGER', 'OPERATIONAL', 'GUEST'],

  // Profiles que tem acessos aos menus
  ADMINISTRATION: ['ADMIN', 'SYSADMIN'],

  FARMER_PORTAL: ['FARMER_PORTAL']
}

export function validRule(rules) {
  if (!Array.isArray(rules) || !window.localStorage || !window.localStorage.entitlements) return false
  const entitlements = window.localStorage.entitlements.split(',')
  return rules.some((rule) => entitlements.includes(rule))
}
